import type { BillingPlan, BillingPlanKey, BillingSubscription } from '@store/api/billing/billingApi';

const PLAN_NAME_BY_KEY: Record<string, string> = {
  free: 'Free',
  pro: 'Pro',
  pro_plus: 'Pro+',
};

const formatUnknownPlanKey = (planKey: BillingPlanKey) =>
  planKey
    .split('_')
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

export const getBillingPlanDisplayName = (
  planKey: BillingPlanKey | null | undefined,
  plans: BillingPlan[] = []
) => {
  if (!planKey) {
    return '';
  }

  const planName = plans.find(plan => plan.key === planKey)?.name;
  if (planName && planName !== planKey) {
    return planName;
  }

  return PLAN_NAME_BY_KEY[planKey] || formatUnknownPlanKey(planKey);
};

export const isPaidBillingPlanKey = (planKey: BillingPlanKey | null | undefined) =>
  Boolean(planKey && planKey !== 'free');

export const isInactivePaidSubscription = (
  subscription: BillingSubscription | null | undefined
): boolean => {
  if (!subscription) {
    return false;
  }
  return isPaidBillingPlanKey(subscription.plan) && !subscription.isActive;
};
